import _ from 'lodash';
import math from '../../util/math';
import { ERROR, LOADING, SUCCESS, RESET, ALL_LOADED } from './CTAActions';

const INITIAL_STATE = {
  allLoaded: false,
  isLoading: false,
  success: false,
  error: '',
  data: [],
  hash: ''
};

const CTAReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ERROR: {
      return { ...state, error: action.error };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case RESET: {
      return { ...state, allLoaded: false, data: [] };
    }
    case SUCCESS: {
      return { ...state, isLoading: false, data: [...state.data, action.data] };
    }
    case ALL_LOADED: {
      return { ...state, allLoaded: true };
    }
    default:
      return state;
  }
};

export default CTAReducer;
